module.exports = __webpack_public_path__ + "img/21.6b42b37e.png";